class ProductSpecifications extends HTMLElement {
    constructor() {
        super()

        this.unsubscribe = null
    }

    connectedCallback() {
        const listener = event => {
            const variantEvent = event
            const variantId = variantEvent.detail.id

            const iconAccordions = this.querySelectorAll(
                '.product-specifications__details.text-icons'
            );

            iconAccordions.forEach((accordion) => {
                accordion.querySelectorAll('[js-product-specifications="spec"]').forEach((spec) => {
                    spec.classList.add("is-hidden")

                    const id = Number(spec.getAttribute("data-variant-id"))

                    if (id === variantId && !spec.classList.contains("is-empty")) {
                        spec.classList.remove("is-hidden")
                    }
                })
            })

            const imageAccordions = this.querySelectorAll(
                '.product-specifications__details.text-image'
            );

            imageAccordions.forEach(
                accordion => {
                    // If there are no variant specific metaobjects to show, don't hide the product metaobjects
                    if (accordion.querySelectorAll('.product-specifications__inner--text-image--variant').length == 0) return;

                    accordion.querySelectorAll('[js-product-specifications="spec"]').forEach((spec) => {
                        spec.classList.add("is-hidden")
                        spec.classList.remove('product-specifications__inner--text-image--visible')

                        const id = Number(spec.getAttribute("data-variant-id"))

                        if (id === variantId && !spec.classList.contains("is-empty")) {
                            spec.classList.remove("is-hidden")
                            spec.classList.add('product-specifications__inner--text-image--visible')
                        }
                    })
                }
            )
        }

        document.addEventListener("variant:update", listener)

        this.unsubscribe = () =>
            document.removeEventListener("variant:update", listener)
    }

    disconnectedCallback() {
        if (this.unsubscribe) {
            this.unsubscribe()
        }

        this.unsubscribe = null
    }
}

customElements.define("uwp-product-specifications", ProductSpecifications)
